import { useMemo } from "react";

import Box from "ds/components/Box";
import Typography from "ds/components/Typography";

import styles from "./styles.module.css";

type SpaceData = {
  id: string;
  name: string;
  parentSpace: string | null;
  inheritEntities: boolean;
};

type SpaceSelectorAvailabilitySummaryProps = {
  spaces: SpaceData[];
  checkedSpaceIds: Set<string>;
};

const SpaceSelectorAvailabilitySummary = ({
  spaces,
  checkedSpaceIds,
}: SpaceSelectorAvailabilitySummaryProps) => {
  const { originCount, inheritedCount } = useMemo(() => {
    let origin = 0;
    let inherited = 0;

    checkedSpaceIds.forEach((id) => {
      const space = spaces.find((s) => s.id === id);
      if (space) {
        if (space.inheritEntities) {
          inherited++;
        } else {
          origin++;
        }
      }
    });

    return { originCount: origin, inheritedCount: inherited };
  }, [checkedSpaceIds, spaces]);

  return (
    <Box align="center" gap="small" className={styles.summary}>
      <Typography variant="p-t7" tag="span">
        Current availability:
      </Typography>
      <Box align="center" gap="small" className={styles.summaryValues}>
        <Box align="center" gap="small">
          <Typography variant="p-body3" tag="span" className={styles.counter}>
            {originCount}
          </Typography>
          <Typography variant="p-body3" tag="span">
            origin,
          </Typography>
        </Box>
        <Box align="center" gap="small">
          <Typography variant="p-body3" tag="span" className={styles.counter}>
            {inheritedCount}
          </Typography>
          <Typography variant="p-body3" tag="span">
            inherited
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

SpaceSelectorAvailabilitySummary.displayName = "SpaceSelectorAvailabilitySummary";

export default SpaceSelectorAvailabilitySummary;
